import { useProfilePhoto } from 'hooks/useProfilePhoto';
import SafeImage, { SafeImageProps } from './SafeImage';

type ProfilePhotoProps = SafeImageProps & {
    fallbackColor?: 'pink' | 'grey';
    src?: string | null;
};

export function ProfilePhoto({ fallbackColor = 'pink', ...safeImageProps }: ProfilePhotoProps) {
    const { profilePhotoSrc, fallbackSrc } = useProfilePhoto({
        color: fallbackColor,
        profilePhoto: safeImageProps.src,
    });

    return (
        <SafeImage
            {...safeImageProps}
            src={profilePhotoSrc || fallbackSrc}
            alt=""
        />
    );
}
